import { Reveal } from "../Reveal";
import { IMAGES } from "../../lib/constants";

export const About = ({ t }) => (
  <section
    id="about"
    data-testid="about-section"
    className="py-24 md:py-36"
    style={{ background: "var(--white)" }}
  >
    <div className="max-w-[1400px] mx-auto px-6 md:px-12">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16 items-start">
        <div className="md:col-span-5">
          <Reveal>
            <span className="eyebrow mb-8">{t.about.label}</span>
          </Reveal>
          <Reveal delay={100}>
            <h2 className="display-xl text-[34px] md:text-[44px] lg:text-[52px] mt-6">
              {t.about.title}
            </h2>
          </Reveal>

          <Reveal delay={250}>
            <div className="mt-10 grid grid-cols-2 gap-y-10 gap-x-8 max-w-md">
              {t.about.stats.map((s) => (
                <div key={s.label}>
                  <div
                    className="font-serif text-4xl md:text-[42px]"
                    style={{ color: "var(--gold-500)" }}
                  >
                    {s.value}
                  </div>
                  <div
                    className="eyebrow mt-3"
                    style={{ color: "var(--fg-muted)" }}
                  >
                    {s.label}
                  </div>
                </div>
              ))}
            </div>
          </Reveal>
        </div>

        <div className="md:col-span-7">
          <Reveal delay={180}>
            <img
              src={IMAGES.about}
              alt="Kadra Talent operations team coordinating international workforce deployment"
              className="w-full h-[420px] md:h-[560px] object-cover editorial-img"
              style={{ borderRadius: "var(--radius-card)" }}
            />
          </Reveal>
          <Reveal delay={320}>
            <p
              className="mt-10 text-base md:text-lg leading-relaxed max-w-2xl"
              style={{ color: "var(--fg-muted)" }}
            >
              {t.about.body}
            </p>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
